import { useState, useEffect } from 'react'
import { useI18n } from '../i18n'
import Modal from './Modal'

/**
 * Модалка создания конфигурации. Стилизованная замена window.prompt.
 */
export default function CreateConfigModal({ open, onClose, onCreate, initialName = '', title, submitLabel }) {
  const { t } = useI18n()
  const [name, setName] = useState('')

  useEffect(() => {
    if (open) {
      setName(initialName || '')
    }
  }, [open])

  function handleSubmit(e) {
    e.preventDefault()
    const trimmed = name.trim()
    if (trimmed) {
      onCreate(trimmed)
      onClose()
    }
  }

  return (
    <Modal
      open={open}
      title={title || t('settings.config.createModalTitle') || 'Новая конфигурация'}
      titleId="create-config-modal-title"
      onClose={onClose}
      footer={
        <div className="modal-actions">
          <button type="button" className="modal-btn modal-btn-secondary" onClick={onClose}>
            {t('common.cancel') || 'Отмена'}
          </button>
          <button
            type="submit"
            form="create-config-form"
            className="modal-btn modal-btn-primary"
            disabled={!name.trim()}
          >
            {submitLabel || t('settings.config.create') || 'Создать'}
          </button>
        </div>
      }
    >
      <form id="create-config-form" onSubmit={handleSubmit} className="modal-form">
        <label>
          {t('settings.config.namePrompt') || 'Название конфига:'}
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="New config"
            autoFocus
          />
        </label>
      </form>
    </Modal>
  )
}
